// extracted by mini-css-extract-plugin
export var infoRow = "_o1-2";
export var labelContainer = "_o1-0";
export var rightInfo = "_o1-1";